import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import styles from '../POWorkflowManagement/po_workflow_management.module.css';
import { SystemPOWorkflowTable } from './system_po_workflow_table.component';
import { SystemPOWorkflowDashboardTab } from './system_po_workflow_dashboard_tab.component';

export const SystemPOWorkflowManagementPage = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('action-required');

  // Keep same tabs UI, but system-backed
  const tabTitle = useMemo(() => 'System Invoice Management', []);

  const handleBackClick = () => {
    navigate('/rov');
  };

  return (
    <DashboardLayout padding={true}>
      <div className={styles['po-workflow-container']}>
        <div className={styles['po-workflow-header']}>
          <div className={styles['header-left']}>
            <div className={styles['back-icon-container']} onClick={handleBackClick}>
              <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
            </div>
            <h1 className={styles['page-title']}>{tabTitle}</h1>
          </div>
        </div>

        <div className={styles['tabs-container']}>
          <button
            className={`${styles['tab']} ${selectedTab === 'dashboard' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('dashboard')}
          >
            Dashboard
          </button>
          <button
            className={`${styles['tab']} ${selectedTab === 'action-required' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('action-required')}
          >
            Active POs
          </button>
          <button
            className={`${styles['tab']} ${selectedTab === 'stopped-invoices' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('stopped-invoices')}
          >
            Stopped Invoices(POs)
          </button>
          <button
            className={`${styles['tab']} ${selectedTab === 'all-invoices' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('all-invoices')}
          >
            Closed POs
          </button>
          <button
            className={`${styles['tab']} ${selectedTab === 'archive' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('archive')}
          >
            Archived POs
          </button>
          <button
            className={`${styles['tab']} ${selectedTab === 'all-invoices-full' ? styles['tab-active'] : ''}`}
            onClick={() => setSelectedTab('all-invoices-full')}
          >
            All Invoice
          </button>
        </div>

        {selectedTab === 'dashboard' && <SystemPOWorkflowDashboardTab />}
        {selectedTab !== 'dashboard' && <SystemPOWorkflowTable selectedTab={selectedTab} />}
      </div>
    </DashboardLayout>
  );
};
